import config from "../config";

export function formatDate(date1) {
  let date = new Date(date1);
    const monthNames = config.mounth;
 // console.log("object  date",date);
    const day = date.getDay();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
  
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  export function countWord(s){
    s = s.replace(/(^\s*)|(\s*$)/gi,"");
    s = s.replace(/[ ]{2,}/gi," ");
    s = s.replace(/\n /,"\n");
   return s.split(' ').length;
  }

  export function formatDateTextFieldDate(date) {

    function appendLeadingZeroes(n){
      if(n <= 9){
        return "0" + n;
      }
      return n
    }
    
    const day = date.getDate();
    const month = date.getMonth()+1;
    const year = date.getFullYear();
  
    return year + '-' +appendLeadingZeroes(month) + '-' + appendLeadingZeroes(day);

 
  }

  export function formatCompilerBirthDate(value) {
    if (!value || String(value).trim() === '') return null;

    const str = String(value).trim();

    const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
    if (isoMatch) {
      const [, year, month, day] = isoMatch;
      return `${parseInt(day, 10)}.${parseInt(month, 10)}.${year}`;
    }

    const isoDateTimeMatch = /^(\d{4})-(\d{2})-(\d{2})T/.exec(str);
    if (isoDateTimeMatch) {
      const [, year, month, day] = isoDateTimeMatch;
      return `${parseInt(day, 10)}.${parseInt(month, 10)}.${year}`;
    }

    const parsed = new Date(str);
    if (!isNaN(parsed.getTime())) {
      return parsed.toLocaleDateString('tr-TR');
    }

    return str;
  }

  export function normalizeCompilerBirthDateForInput(value) {
    if (!value) return value;
    const str = String(value).trim();
    const match = /^(\d{4}-\d{2}-\d{2})/.exec(str);
    return match ? match[1] : str;
  }

  export function isEmptyOrZeroDate(value) {
    if (value === null || value === undefined) return true;

    const str = String(value).trim();
    if (str === '') return true;
    if (str.startsWith('0000-00-00')) return true;

    const date = value instanceof Date ? value : new Date(str);
    if (isNaN(date.getTime())) return true;
    if (date.getFullYear() < 1900) return true;

    return false;
  }

  export function formatComplationDate(value, emptyLabel = 'Bilinmiyor') {
    if (isEmptyOrZeroDate(value)) return emptyLabel;
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleDateString('tr-TR');
  }

  export function normalizeComplationDateForInput(value) {
    if (isEmptyOrZeroDate(value)) return '';
    const str = String(value).trim();
    const match = /^(\d{4}-\d{2}-\d{2})/.exec(str);
    return match ? match[1] : '';
  }

 export function convertMiliseconds(miliseconds, format) {
    var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;
    
    total_seconds = parseInt(Math.floor(miliseconds / 1000));
    total_minutes = parseInt(Math.floor(total_seconds / 60));
    total_hours = parseInt(Math.floor(total_minutes / 60));
    days = parseInt(Math.floor(total_hours / 24));
  
    seconds = parseInt(total_seconds % 60);
    minutes = parseInt(total_minutes % 60);
    hours = parseInt(total_hours % 24);
    
    switch(format) {
    case 's':
      return total_seconds;
    case 'm':
      return total_minutes;
    case 'h':
      return total_hours;
    case 'd':
      return days;
    default:
      return { d: days, h: hours, m: minutes, s: seconds };
    }
  };